// Analitika ekranlari uchun umumiy CSV-yuklab-olish (DataTable pattern'iga mos:
// UTF-8 BOM → Excel kirill/lotin harflarni to'g'ri ochsin + quote-escape).
// `table` — birinchi qatori sarlavhalar bo'lgan 2D massiv. Fayl nomiga sana qo'shiladi.
export function downloadCsv(baseName: string, table: (string | number)[][]): void {
  // CSV-injection (F52): formula-prefiksli (= + - @ TAB CR) matn oldiga `'`.
  const esc = (v: string | number): string => {
    const s = String(v)
    const neutral = typeof v === 'string' && /^[=+\-@\t\r]/.test(s) ? `'${s}` : s
    return `"${neutral.replace(/"/g, '""')}"`
  }
  const body = table.map((row) => row.map(esc).join(',')).join('\n')
  const blob = new Blob([`﻿${body}`], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${baseName}-${new Date().toISOString().slice(0, 10)}.csv`
  a.click()
  URL.revokeObjectURL(url)
}
